import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Imagen3 from "../../../images/modulo12/lavaropa.png";
import Imagen4 from "../../../images/modulo12/oportunidades.png";

const Actividad1 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[2];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[3].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[3].path}`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[1].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[1].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-4">
        <h2>
          ¿Los hombres y las mujeres tienen las mismas oportunidades en el Perú?
        </h2>
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
            <p>
              Muchas veces, la familia, la escuela y las religiones piensan que
              los hombres y las mujeres deben{" "}
              <strong>comportarse de distinta manera.</strong>
            </p>
            <p>
              Esto hace que las mujeres no tengan las mismas oportunidades que
              los hombres. Las pone en una situación de{" "}
              <strong>desigualdad</strong>.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen3} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen4} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Por ejemplo, algunos creen que es más importante que los niños
              terminen la escuela y no las niñas. Piensan que las mujeres están
              mejor si se quedan en su casa. También creen que hay trabajos que
              no son para mujeres porque no son lo suficientemente fuertes.
              Finalmente, es usual que a las mujeres se les pague menos por
              hacer el mismo trabajo que un hombre.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea el título del texto ¿Los hombres y las mujeres tienen las mismas
            oportunidades en el Perú? Pregunte a niños y niñas qué piensan al
            respecto. Pida a un niño o una niña que lea el primer párrafo del
            texto.
          </li>
          <li>
            Resalte que en la familia, la escuela, las religiones y en la
            sociedad en general se comparten algunas creencias acerca de las
            características de hombres y mujeres y de cómo deben comportarse.
            Pida que describan la primera imagen del texto. Por ejemplo:
            <ul>
              <li>
                <li>“¿Qué está haciendo la niña en la imagen? ¿Y el niño?”</li>
              </li>
            </ul>
          </li>
          <li>
            Pida a un niño o niña que lea el segundo párrafo del texto y a otro
            que lea el tercer párrafo.
          </li>
          <li>
            Retome la pregunta del título del texto y resalte que muchas veces
            estas creencias distintas sobre cómo de deben comportarse los
            hombres y las mujeres ponen a la mujer en desventaja. A ello le
            llamamos desigualdad entre hombres y mujeres.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
